const INITIAL_STATE = {
  show_commit: false,
  snackbar: { message: null, severity: null },
  user_permission: JSON.parse(localStorage.getItem("user"))?.perms,
  tokenTimer: parseInt(localStorage.getItem("token")),
  site_list: [],
  site_list_loaded: false,
  domain_list: [],
  refresh_rate: 2
};

const reducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_COMMIT': {
      return {
        ...state,
        show_commit: action.payload == "1"
      }
    }
    case 'SET_USER_PERMISSION': return {
      ...state,
      user_permission: action.payload
    }
    case 'SHOW_SNACKBAR': return {
      ...state,
      snackbar: action.payload
    }
    case 'HIDE_SNACKBAR': return {
      ...state,
      snackbar: action.payload
    }
    case 'SET_TOKEN_TIMER': return {
      ...state,
      tokenTimer: action.payload
    }
    case 'SET_SITE_LIST': return {
      ...state,
      site_list: action.payload,
      site_list_loaded: true
    }
    case 'SET_DOMAIN_LIST': return {
      ...state,
      domain_list: action.payload
    }
    case 'SET_REFRESH_RATE': return {
      ...state,
      refresh_rate: action.payload
    }

    default:
      return state;
  }
}

export default reducers;